export const Services = (props) => {
  return (
    <div id='services' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Our Services</h2>
          
        </div>
        <div className='row ser-grid' >
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className='col-md-3 col-sm-6 d-flex'>
                {' '}
                <div className="servicecrd">
                  <img src={d.img} width="100%" height="200px" alt={d.name}></img>
                  <div className='service-desc'>
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              </div>
            ))
            : 'loading'}
        </div>

      </div>
    </div>
  )
}
